import React, { useState, useEffect, useCallback } from "react";
import { Layout, Row, Col, Skeleton } from "antd";
import "./detail.scss";
import axiosInstance from "@/axios/axiosInstance";
import VideoPlay from "@/assets/VideoPlayer";
import tool from "@/assets/tool";
import { useLocation } from "react-router-dom";

const VideoDetailPage = () => {
  // const navigate = useNavigate();
  const [videoDetail, setVideoDetail] = useState({});
  const [videoListOther, setVideoListOther] = useState([]);
  const [videoListBott, setVideoListBott] = useState([]);
  const [user, setUser] = useState({});
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const id = queryParams.get("id");
  const profilePictureUrl = queryParams.get("profilePictureUrl");
  const nickName = queryParams.get("nickName");
  useEffect(() => {
    if (id) {
      fetchDetails(id);
      const user = {
        nickName: nickName,
        profilePictureUrl: profilePictureUrl,
      };
      setUser(user);
    }
  }, [id, nickName, profilePictureUrl]);

  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `video/page/detail?videoId=${id}`
      );
      document.title = `渐风AI - ${response.data.data.title} ` || "渐风AI";
      setVideoDetail(response.data.data);
      getVideoList(response.data.data);
      getVideoListBott();
    } catch (error) {
      console.error("Error fetching video details:", error);
    }
  };
  const getVideoList = async (data) => {
    try {
      const response = await axiosInstance.get(
        `/video/page/list?userId=${data.userId}&page=1&limit=4`
      );
      const videos = response.data.data;
      setVideoListOther(videos);
    } catch (error) {
      console.error("Error fetching other videos:", error);
    }
  };
  const getVideoListBott = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        `/video/page/list?page=1&limit=12`
      );
      const videos = response.data.data;
      setVideoListBott(videos);
    } catch (error) {
      console.error("Error fetching bottom videos:", error);
    }
  }, [setVideoListBott]);

  const toDetail = (record) => {
    const params = new URLSearchParams({
      id: record.videoId,
      profilePictureUrl: record.profilePictureUrl,
      nickName: record.nickName,
    });
    const url = `/video_detail?${params.toString()}`;
    window.open(url, "_blank"); // 在新窗口或新标签页中打开
  };

  const getLabel = (l) => {
    const labels = [
      { key: "1", value: "图像处理" },
      { key: "2", value: "深度学习" },
      { key: "3", value: "计算机视觉" },
      { key: "4", value: "机器学习" },
      { key: "5", value: "自然语言处理" },
      { key: "6", value: "pytorch" },
      { key: "7", value: "全部" },
      { key: "8", value: "Agents" },
      { key: "9", value: "大模型开发" },
      { key: "10", value: "模型调优" },
      { key: "11", value: "AI数据" },
      { key: "12", value: "训练推理" },
      { key: "13", value: "AI技术原理" },
      { key: "14", value: "AI基础研究" },
      { key: "15", value: "具身智能" },
      { key: "16", value: "机器人" },
      { key: "17", value: "行业+" },
    ];
    const label = labels.find((v) => v.key === l)?.value;
    return label || "未知";
  };
  const sectionStyle = (v) => ({
    backgroundImage: `url(${v.cover})`,
    backgroundRepeat: "no-repeat",
    // backgroundSize: "100% 100%",
    width: "100%",
    height: "188px",
    padding: "10px",
    paddingTop: "30px",
    color: "#fff",
    backgroundSize: "cover",
    cursor: "pointer",
  });

  return (
    <Layout className="video_detail">
      <div className="videolist-hea">
        <div className="name">教程视频</div>
        <div className="name name_titke">{videoDetail.title}</div>
        <div className="name_time">
          {videoDetail.createTime && videoDetail.createTime.split(" ")[0]}{" "}
          <span>来源为用户上传，如有侵权请申诉</span>
        </div>
      </div>
      <div className="content">
        {videoDetail.videoLocal ? (
          <VideoPlay
            src={videoDetail.videoLocal}
            width="50vw"
            height="70vh"
            autoplay={true}
          />
        ) : (
          <div className="detail_user_video">
            <iframe
              src={tool.convertVideoUrlToEmbedUrl(videoDetail.videoUrl)}
              scrolling="no"
              border="0"
              frameborder="no"
              framespacing="0"
              allowfullscreen="true"
              title="视频播放器" // 添加描述性的 title 属性
            ></iframe>
          </div>
        )}
        <div className="right">
          <div className="top">
            <span>
              <img
                src={`/file/${videoDetail.profilePictureUrl}`}
                className="tx"
                alt=""
              />
              <span className="nickName">
                {user.nickName || tool.hideMiddleFour(videoDetail.phone)}
              </span>
            </span>
          </div>
          {/* <span>作者其他视频</span> */}
          <div className="bottom">
            {videoListOther.length ? (
              videoListOther.map((v, index) => (
                <div
                  key={index}
                  className="detail_video"
                  onClick={() => toDetail(v)}
                >
                  <div style={sectionStyle(v)}>
                    <div className="video-fot">
                      <div className="title child aiTitle" title={v.title}>
                        {v.title}
                      </div>
                      <div className="child label">
                        <div className="child send">
                          <span className="nickName">
                            {user.nickName || tool.hideMiddleFour(v.phone)}
                          </span>
                        </div>
                        <div className="child lastC">
                          <span>
                            {v.createTime && v.createTime.split(" ")[0]}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <Skeleton active paragraph={{ rows: 4 }} />
            )}
          </div>
        </div>
      </div>
      <div className="detail_bott">
        <h3>相关视频</h3>
        <Row gutter={[16, 16]}>{renderVideoList(videoListBott)}</Row>
      </div>
      <div className="detail_bott">
        <h3>其他用户还看</h3>
        <Row gutter={[16, 16]}>{renderVideoList(videoListBott)}</Row>
      </div>
    </Layout>
  );

  function renderVideoList(videos) {
    const sectionStyle = (v) => ({
      backgroundImage: `url(${v.cover})`,
      backgroundRepeat: "no-repeat",
      width: "100%",
      height: "166px",
      padding: "10px",
      paddingTop: "30px",
      color: "#fff",
      backgroundSize: "cover",
      cursor: "pointer",
    });
    return videos.length ? (
      videos.map((v, index) => (
        // 修改 Col 的响应式属性
        <Col xs={12} sm={8} md={6} lg={4} key={index}>
          <div style={sectionStyle(v)}>
            <div className="title child video-title" title={v.title}>
              {v.title}
            </div>
          </div>
          <div className="video-fot" onClick={() => toDetail(v)}>
            <div className="child send">
              <img
                src={`/file/${v.profilePictureUrl}`}
                alt={""}
                className="tx"
              />
              <span className="nickName">
                {v.nickName || tool.hideMiddleFour(v.phone)}
              </span>
              <span>{v.createTime.split(" ")[0]}</span>
            </div>
            <div className="child lastC">
              <span className={`label_${v.label}`}>{getLabel(v.label)}</span>
            </div>
          </div>
        </Col>
      ))
    ) : (
      <Skeleton active paragraph={{ rows: 4 }} />
    );
  }
};

export default VideoDetailPage;
